import { useLightMode } from '@/hooks/useLightMode'

import { Notification } from '@/graphql/appsync-notifications'

import { getNotificationToastTokens } from '../styles/tokens'
import { FlagNotificationTitle } from './FlagNotificationTitle'
import { NotificationSubtitle } from './NotificationSubtitle'
import { NotificationToastShell } from './NotificationToastShell'

export const FlagNotification = ({
  notification,
  onCancel,
}: {
  notification: Notification
  onCancel?: (incidentTimeStamp: string) => void
}) => {
  const tokens = getNotificationToastTokens(useLightMode())
  return (
    <NotificationToastShell
      accentColor={tokens.danger}
      notificationTimestamp={notification?.notificationTimestamp}
      onCancel={onCancel}
    >
      <FlagNotificationTitle notification={notification} />
      <NotificationSubtitle
        facilityShortName={notification?.facilityShortName}
        sourceName={notification?.incidentSourceName}
        timestamp={notification?.notificationTimestamp}
      />
    </NotificationToastShell>
  )
}
